const IS_SERVER = typeof window === 'undefined';

const localKeys = {
  user: 'USER',
  currentStore: 'CURRENT_STORE',
  searchAll: 'SEARCH_ALL',
};

export const clearSession = () => sessionStorage.clear();

export const getStores = () => {
  let stores = JSON.parse(!IS_SERVER ? localStorage.getItem('stores') : '[]');
  return Array.isArray(stores) ? stores : [];
};

export const setStores = (stores) => {
  localStorage.setItem('stores', JSON.stringify(stores));
};
export const removeStores = () => {
  localStorage.removeItem('stores');
};

export const getStore = (id = '') => {
  let stores = JSON.parse(!IS_SERVER ? localStorage.getItem('stores') : '[]');
  if (!Array.isArray(stores)) {
    return null;
  }
  let found_store = stores.find((store) => store.square_id === id);
  return found_store ? found_store : null;
};

export const setUser = (user) =>
  sessionStorage.setItem(localKeys.user, JSON.stringify(user));
export const removeUser = () => sessionStorage.removeItem(localKeys.user);
export const getUser = () => {
  let user = JSON.parse(
    !IS_SERVER ? sessionStorage.getItem(localKeys.user) : 'null'
  );
  return user ?? null;
};

export const setCurrentStore = (store) =>
  sessionStorage.setItem(localKeys.currentStore, JSON.stringify(store));
export const removeCurrentStore = () =>
  sessionStorage.removeItem(localKeys.currentStore);
export const getCurrentStore = () => {
  let store_id = JSON.parse(
    !IS_SERVER ? sessionStorage.getItem(localKeys.currentStore) : 'null'
  );
  return store_id !== null ? store_id : null;
};

export const setSearchAll = () =>
  sessionStorage.setItem(localKeys.searchAll, 'yes');
export const removeSearchAll = () =>
  sessionStorage.removeItem(localKeys.searchAll);
export const getSearchAll = () => {
  let searchAll = !IS_SERVER
    ? sessionStorage.getItem(localKeys.searchAll)
    : null;
  return searchAll !== null;
};

export const setReturnStoreInStorage = (store) => {
  sessionStorage.setItem('return_store', JSON.stringify(store));
};

export const getReturnStore = () => {
  let store = JSON.parse(
    !IS_SERVER ? localStorage.getItem('return_store') : 'null'
  );
  return store !== null ? store : null;
};

export const setSessionRedirected = () =>
  sessionStorage.setItem('redirected', 'yes');
export const removeSessionRedirected = () =>
  sessionStorage.removeItem('redirected');
export const getSessionRedirected = () => sessionStorage.getItem('redirected');

export const getLastRefresh = () => {
  let time = !IS_SERVER
    ? !isNaN(Number(localStorage.getItem('last-refesh')))
      ? Number(localStorage.getItem('last-refesh'))
      : 0
    : 0;
  return time;
};

export const setLastRefresh = (time) => {
  localStorage.setItem('last-refesh', time);
};
